import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const defaultDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

export const getCurrentYear = (): number => {
  return new Date().getFullYear();
};

export const modifiedDate = (date: Date, customFormat?: string): string => {
  return dayjs
    .utc(date)
    .local()
    .format(customFormat || defaultDateTimeFormat);
};

export const formatDateUtc = (date: Date, customFormat?: string): string => {
  return dayjs.utc(date).format(customFormat || defaultDateTimeFormat);
};

export const formatDateToMMDDYYYY = (date: string): string => dayjs(date).format('MM/DD/YYYY');
